import { useTranslation } from 'react-i18next';

export function LangSwitcher() {
  const { i18n } = useTranslation();
  return (
    <div className="flex items-center gap-1 text-xs">
      <button
        type="button"
        onClick={() => void i18n.changeLanguage('es')}
        className={i18n.language === 'es' ? 'font-bold' : ''}
      >
        ES
      </button>
      <span>|</span>
      <button
        type="button"
        onClick={() => void i18n.changeLanguage('en')}
        className={i18n.language === 'en' ? 'font-bold' : ''}
      >
        EN
      </button>
    </div>
  );
}
